import React, { useEffect, useRef } from 'react'
import ResultsSection, { NotAvailable } from './ResultsSection'
import { Chart } from 'chart.js/auto'
import useTranslation from '../shared/TranslationProvider'
import useCareerExploration from './CareerExplorationProvider'
import { cn } from '~/lib/utils'

const EducationAndExperienceSection = ({ career, ...props }) => {
  const { requiredEducation, relatedWorkExperience } = useCareerExploration()
  const { related_work_experiences, required_education } = career
  const { t } = useTranslation('education_and_experience')

  const showRequiredEducation = !!requiredEducation(career)?.length

  const showRelatedWorkExperience = !!relatedWorkExperience(career)?.length

  if (!showRelatedWorkExperience && !showRequiredEducation)
    return (
      <NotAvailable
        section="education_and_experience"
        career={career}
        {...props}
      />
    )
  return (
    <ResultsSection
      section="education_and_experience"
      career={career}
      {...props}
    >
      <div className="flex justify-between">
        {showRelatedWorkExperience && (
          <PieChart
            dataArr={related_work_experiences}
            title={t('related_work_experience')}
          />
        )}
        {showRequiredEducation && (
          <PieChart
            dataArr={required_education}
            title={t('required_education')}
          />
        )}
      </div>
    </ResultsSection>
  )
}

export default EducationAndExperienceSection

const PieChart = ({ dataArr, title }) => {
  const { compare } = useCareerExploration()

  const chartRef = useRef(null)
  const chartInstanceRef = useRef(null)

  useEffect(() => {
    if (chartRef.current) {
      const ctx = chartRef.current.getContext('2d')

      if (chartInstanceRef.current) {
        chartInstanceRef.current.destroy()
      }

      const labels = dataArr.map((experience) => experience[0])
      const data = dataArr.map((experience) => experience[1])

      chartInstanceRef.current = new Chart(ctx, {
        type: 'pie',
        data: {
          labels: labels,
          datasets: [
            {
              data: data,
              backgroundColor: [
                '#D0E8FF',
                '#FBE38E',
                '#A9F4D0',
                '#FED0EE',
                '#FDD09F',
              ],
            },
          ],
        },
        options: {
          animation: { animateRotate: true },
          plugins: {
            legend: { display: true },
            tooltip: {
              enabled: true,
              callbacks: {
                label: function (ctx) {
                  let label = ctx.label || ''
                  if (ctx.parsed !== null) {
                    label += ': ' + ctx.parsed + '%'
                  }
                  return label
                },
              },
            },
            title: {
              display: true,
              text: title,
            },
          },
        },
      })
    }
  }, [dataArr, title])

  return (
    <div className={cn('', !compare && 'h-96 w-96')}>
      <canvas ref={chartRef} />
    </div>
  )
}
